<script lang="ts">
  export let size: any = '22';
</script>

<svg width={size} height={size} viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M21.0491 10.0834V15.5834C21.0491 19.25 20.1324 20.1667 16.4658 20.1667H7.29911C3.63244 20.1667 2.71577 19.25 2.71577 15.5834V6.41671C2.71577 2.75004 3.63244 1.83337 7.29911 1.83337H8.67411C10.0491 1.83337 10.3516 2.23671 10.8741 2.93337L12.2491 4.76671C12.5974 5.22504 12.7991 5.50004 13.7158 5.50004H16.4658C20.1324 5.50004 21.0491 6.41671 21.0491 10.0834Z"
    class={$$props.class || "stroke-garden-grey-600"}
    stroke-width="1.5"
    stroke-miterlimit="10"
  />
  <path
    d="M11.9374 15.125V10.5416"
    class={$$props.class || "stroke-garden-grey-600"}
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M14.1741 12.8334H9.59077"
    class={$$props.class || "stroke-garden-grey-600"}
    stroke-width="1.5"
    stroke-miterlimit="10"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
